import React, { useState, useEffect } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Login from './pages/Login';
import NewDashboard from './pages/NewDashboard';
import { getToken, setToken, removeToken } from './utils/auth';
import { setLoggingIn } from './services/api';
import { setNetworkLoggingIn } from './services/networkApi';

// App è ora un layout wrapper che fornisce contesto di autenticazione
function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();

  // Verifica autenticazione all'avvio
  useEffect(() => {
    const checkAuthStatus = () => {
      const token = getToken();
      if (token) {
        try {
          const userData = JSON.parse(localStorage.getItem('user'));
          if (userData) {
            setUser(userData);
            setIsAuthenticated(true);
          }
        } catch (error) {
          console.error('Errore nel recupero dei dati utente:', error);
          handleLogout();
        }
      }
      setLoading(false);
    };

    checkAuthStatus();
  }, []);

  // Reindirizza in base all'autenticazione
  useEffect(() => {
    persistentLog('🔄 useEffect redirect triggered', { 
      loading, 
      pathname: location.pathname, 
      isAuthenticated 
    });
    
    if (!loading) {
      // RIMUOVIAMO IL REDIRECT DA LOGIN - lo gestisce handleLogin
      // if (location.pathname === '/login' && isAuthenticated) {
      //   persistentLog('🔄 Redirecting from login to dashboard');
      //   navigate('/', { replace: true });
      // } else 
      if (location.pathname.startsWith('/nlt') && !isAuthenticated) {
        persistentLog('🔄 Redirecting to login (not authenticated)');
        navigate('/login', { replace: true });
      }
    }
  }, [isAuthenticated, loading, location.pathname, navigate]);

  // Funzione per logging persistente
  const persistentLog = (message, data = null) => {
    const timestamp = new Date().toISOString();
    const logEntry = `${timestamp}: [APP] ${message}${data ? ` - ${JSON.stringify(data)}` : ''}`;
    // console.log(logEntry);
    
    try {
      const existingLogs = localStorage.getItem('login_debug_logs') || '';
      localStorage.setItem('login_debug_logs', existingLogs + '\n' + logEntry);
    } catch (e) {
      console.error('Failed to save log to localStorage:', e);
    }
  };

  // Funzioni di autenticazione esposte ai children tramite props
  const handleLogin = (userData, token) => {
    try {
      persistentLog('🔄 handleLogin chiamato', { hasUserData: !!userData, hasToken: !!token });
      
      persistentLog('🔄 setToken...');
      setToken(token);
      
      persistentLog('🔄 localStorage.setItem user...');
      localStorage.setItem('user', JSON.stringify(userData));
      
      persistentLog('🔄 setUser...');
      setUser(userData);
      
      persistentLog('🔄 setIsAuthenticated(true)...');
      setIsAuthenticated(true);
      
      persistentLog('🔄 navigate(/)...');
      navigate('/');
      
      persistentLog('✅ handleLogin completato');
    } catch (error) {
      persistentLog('❌ handleLogin error', { 
        message: error.message, 
        stack: error.stack 
      });
      throw error;
    }
  };

  const handleLogout = () => {
    removeToken();
    localStorage.removeItem('user');
    setUser(null);
    setIsAuthenticated(false);
    navigate('/login');
  };

  // Context che verrà passato ai children tramite props
  const authContext = {
    isAuthenticated,
    user,
    login: handleLogin,
    logout: handleLogout
  };

  if (loading) {
    return <div>Caricamento...</div>;
  }

  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      {/* Outlet renderizza i children definiti nel router, passando le props di autenticazione */}
      <Outlet context={authContext} />
    </>
  );
}

export default App; 